/* src/app/workshop/pages/workshop-depots/workshop-depots.component.scss */
/*# sourceMappingURL=workshop-depots.component.css.map */
